import React, { useState, useEffect } from "react";

const testimonials = [
  {
    text: "CARA literally saved me weeks! The 1-Click Apply filled half my forms in minutes. Total game-changer.",
    name: "Aditi Sharma",
    role: "Bachelor’s Student",
    location: "India",
    stars: 5,
  },
  {
    text: "The Top Applicant Blueprint showed me what real admits had. I leveled up my essays and got scholarships!",
    name: "Neha Verma",
    role: "Master’s Student",
    location: "India",
    stars: 4,
  },
  {
    text: "I compared 5 unis side by side, and CARA’s Graduation Pathway told me exactly where ROI was best. No guesswork.",
    name: "Rahul Iyer",
    role: "Bachelor’s Student",
    location: "India",
    stars: 5,
  },
  {
    text: "After I enrolled, EdviseMe literally deposited $1000 cashback directly into my tuition account. No one else does this. Unreal!",
    name: "Karan Malhotra",
    role: "Bachelor’s Student",
    location: "India",
    stars: 5,
  },
  {
    text: "Essay Boost was wild. It gave me a structure and even improved my vibe. Way less stress.",
    name: "Rohan Patel",
    role: "Master’s Student",
    location: "India",
    stars: 4,
  },
  {
    text: "As a parent, I was amazed at the data-driven reports. They helped us decide the best universities and programs for our daughter with complete clarity.",
    name: "Sangeeta Mehra",
    role: "Parent of Student",
    location: "India",
    stars: 5,
  },
  {
    text: "CARA’s Career Roadmap showed me exactly what steps I need to take to prepare for IAS. It turned a dream into a real plan.",
    name: "Vikram Joshi",
    role: "Bachelor’s Student",
    location: "India",
    stars: 5,
  },
  {
    text: "I was so confused about private universities in India. CARA’s insights showed me which ones fit my goals and budget best — no biased counseling.",
    name: "Shreya Kapoor",
    role: "Bachelor’s Student",
    location: "India",
    stars: 5,
  },
  {
    text: "Best-fit universities + autofill apps = stress-free admissions. I could focus on my career goals instead of paperwork.",
    name: "Fatima Al Mansoori",
    role: "Master’s Student",
    location: "UAE",
    stars: 5,
  },
  {
    text: "I used Essay Boost and Top Applicant Blueprint. Both were crazy helpful, and I actually felt confident sending my application.",
    name: "Wei Ling Tan",
    role: "Master’s Student",
    location: "Singapore",
    stars: 5,
  },
];

const TestimonialsSection = () => {
  const [index, setIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % testimonials.length),
      5000
    );
    return () => clearInterval(interval);
  }, []);

  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    const delta = touchStartX - e.changedTouches[0].clientX;
    if (delta > 50) setIndex((prev) => (prev + 1) % testimonials.length);
    else if (delta < -50) setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const { text, name, role, location, stars } = testimonials[index];

  return (
    <section data-component-id="src\components\common\Testimonial.jsx:98:4" data-component-path="src\components\common\Testimonial.jsx" data-component-line="98" data-component-file="Testimonial.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%7D">
      {/* Desktop / Tablet */}
      <div data-component-id="src\components\common\Testimonial.jsx:100:6" data-component-path="src\components\common\Testimonial.jsx" data-component-line="100" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20md%3Ablock%20bg-%5B%23012D42%5D%20text-white%20py-10%20px-6%20md%3Apx-12%20lg%3Apx-20%22%7D" className="hidden md:block bg-[#012D42] text-white py-10 px-6 md:px-12 lg:px-20">
        <div data-component-id="src\components\common\Testimonial.jsx:101:8" data-component-path="src\components\common\Testimonial.jsx" data-component-line="101" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-5xl%20mx-auto%20text-center%22%7D" className="max-w-5xl mx-auto text-center">
          <h2 data-component-id="src\components\common\Testimonial.jsx:102:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="102" data-component-file="Testimonial.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20font-bold%20mb-3%22%2C%22textContent%22%3A%22What%20Students%20%26%20Parents%20Are%20Saying%22%7D" className="text-3xl font-bold mb-3">What Students & Parents Are Saying</h2>
          <p data-component-id="src\components\common\Testimonial.jsx:103:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="103" data-component-file="Testimonial.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-base%20text-gray-200%20mb-6%22%2C%22textContent%22%3A%22Real%20experiences%2C%20real%20results%20powered%20by%20CARA%20%2B%20EdviseMe.%22%7D" className="text-base text-gray-200 mb-6">
            Real experiences, real results powered by CARA + EdviseMe.
          </p>

          <div data-component-id="src\components\common\Testimonial.jsx:107:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="107" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22transition-all%20duration-500%20ease-in-out%20min-h-%5B160px%5D%22%7D"
            className="transition-all duration-500 ease-in-out min-h-[160px]"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <p data-component-id="src\components\common\Testimonial.jsx:112:12" data-component-path="src\components\common\Testimonial.jsx" data-component-line="112" data-component-file="Testimonial.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22italic%20text-xl%20mb-3%22%2C%22textContent%22%3A%22%E2%80%9C%20%E2%80%9D%22%7D" className="italic text-xl mb-3">“{text}”</p>
            <p data-component-id="src\components\common\Testimonial.jsx:113:12" data-component-path="src\components\common\Testimonial.jsx" data-component-line="113" data-component-file="Testimonial.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-semibold%22%2C%22textContent%22%3A%22%E2%80%93%20%2C%20%2C%22%7D" className="font-semibold">
              – {name}, {role}, {location}
            </p>
            <div data-component-id="src\components\common\Testimonial.jsx:116:12" data-component-path="src\components\common\Testimonial.jsx" data-component-line="116" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mt-1%22%7D" className="flex justify-center mt-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <span data-component-id="src\components\common\Testimonial.jsx:118:16" data-component-path="src\components\common\Testimonial.jsx" data-component-line="118" data-component-file="Testimonial.jsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%98%85%22%7D"
                  key={i}
                  className={`text-lg ${i < stars ? "text-yellow-400" : "text-gray-400"}`}
                >
                  ★
                </span>
              ))}
            </div>
          </div>

          {/* Carousel Dots */}
          <div data-component-id="src\components\common\Testimonial.jsx:129:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="129" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mt-2%20space-x-2%22%7D" className="flex justify-center mt-2 space-x-2">
            {testimonials.map((_, i) => (
              <button data-component-id="src\components\common\Testimonial.jsx:131:14" data-component-path="src\components\common\Testimonial.jsx" data-component-line="131" data-component-file="Testimonial.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                key={i}
                onClick={() => setIndex(i)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  i === index ? "bg-white" : "bg-gray-500"
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div data-component-id="src\components\common\Testimonial.jsx:144:6" data-component-path="src\components\common\Testimonial.jsx" data-component-line="144" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22md%3Ahidden%20bg-%5B%23F9FAFB%5D%20text-%5B%23012D42%5D%20py-8%20px-6%22%7D" className="md:hidden bg-[#F9FAFB] text-[#012D42] py-8 px-6">
        <div data-component-id="src\components\common\Testimonial.jsx:145:8" data-component-path="src\components\common\Testimonial.jsx" data-component-line="145" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-lg%20mx-auto%20text-center%22%7D" className="max-w-lg mx-auto text-center">
          <h2 data-component-id="src\components\common\Testimonial.jsx:146:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="146" data-component-file="Testimonial.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-xl%20font-bold%20mb-3%22%2C%22textContent%22%3A%22What%20Students%20%26%20Parents%20Are%20Saying%22%7D" className="text-xl font-bold mb-3">What Students & Parents Are Saying</h2>
          <p data-component-id="src\components\common\Testimonial.jsx:147:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="147" data-component-file="Testimonial.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-gray-700%20mb-6%22%2C%22textContent%22%3A%22Real%20experiences%2C%20real%20results%20powered%20by%20CARA%20%2B%20EdviseMe.%22%7D" className="text-sm text-gray-700 mb-6">
            Real experiences, real results powered by CARA + EdviseMe.
          </p>

          <div data-component-id="src\components\common\Testimonial.jsx:151:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="151" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22transition-all%20duration-500%20ease-in-out%20min-h-%5B180px%5D%22%7D"
            className="transition-all duration-500 ease-in-out min-h-[180px]"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <p data-component-id="src\components\common\Testimonial.jsx:156:12" data-component-path="src\components\common\Testimonial.jsx" data-component-line="156" data-component-file="Testimonial.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22italic%20text-base%20mb-3%22%2C%22textContent%22%3A%22%E2%80%9C%20%E2%80%9D%22%7D" className="italic text-base mb-3">“{text}”</p>
            <p data-component-id="src\components\common\Testimonial.jsx:157:12" data-component-path="src\components\common\Testimonial.jsx" data-component-line="157" data-component-file="Testimonial.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-semibold%22%2C%22textContent%22%3A%22%E2%80%93%20%2C%20%2C%22%7D" className="font-semibold">
              – {name}, {role}, {location}
            </p>
            <div data-component-id="src\components\common\Testimonial.jsx:160:12" data-component-path="src\components\common\Testimonial.jsx" data-component-line="160" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mt-1%22%7D" className="flex justify-center mt-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <span data-component-id="src\components\common\Testimonial.jsx:162:16" data-component-path="src\components\common\Testimonial.jsx" data-component-line="162" data-component-file="Testimonial.jsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%98%85%22%7D"
                  key={i}
                  className={`text-lg ${i < stars ? "text-[#FF424E]" : "text-gray-400"}`}
                >
                  ★
                </span>
              ))}
            </div>
          </div>

          {/* Carousel Dots */}
          <div data-component-id="src\components\common\Testimonial.jsx:173:10" data-component-path="src\components\common\Testimonial.jsx" data-component-line="173" data-component-file="Testimonial.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mt-2%20space-x-2%22%7D" className="flex justify-center mt-2 space-x-2">
            {testimonials.map((_, i) => (
              <button data-component-id="src\components\common\Testimonial.jsx:175:14" data-component-path="src\components\common\Testimonial.jsx" data-component-line="175" data-component-file="Testimonial.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                key={i}
                onClick={() => setIndex(i)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  i === index ? "bg-[#FF424E]" : "bg-gray-400"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;